
export interface DbZone {
    zoneTitles?: Array<string>;
    list?: Array<Zone>;
    // Incremented by every writer. Missing on legacy documents is revision 0.
    revision?: number;
}

export interface Zone {
    id?: string;
    name?: string;
    cols?: number;
    rows?: number;
    zones?: Array<Zone>;
    placements?: number;
    //sensorIds?: Array<string>;
    externalId?: string
    mapData?: ZoneMapData;   // optional spatial mapping; absent = not mapped
}

// Optional spatial-mapping payload attached to a Zone. Additive: when null the
// zone behaves exactly as before and no map surfaces render it.
export interface ZoneMapData {
    floorPlanId?: string;    // which FloorPlan this zone is drawn on
    shape?: ZoneShape;
    color?: string;          // fill color (reuses the existing swatch palette)
}

export interface ZoneShape {
    type?: ZoneShapeType;
    // NORMALIZED 0-1 coordinates relative to the floor plan image, so the image
    // can be re-uploaded at any resolution / rendered at any size without
    // touching zone data.
    //   rect:    [x, y, w, h]
    //   pin:     [x, y]
    //   polygon: [x1, y1, x2, y2, ...]
    points?: Array<number>;
}

export type ZoneShapeType = 'rect' | 'polygon' | 'pin';

// export interface ZonePhase {
//     phaseName?: string;
//     zoneIds?: Array<string>;
// }

// export interface HarvestZonePhases extends Zone {
//     zones: Array<ZonePhase>;
// }

// export interface ZoneSetter {
//     id?: string;
//     count?: number;
// }
